export enum GaugeLevelMode {
    FIVE,
    SIX
}


export interface AQIPollution {
    majorIndexLevel: string;
    majorPollutant: string;
    measuringDate: string;
}